import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const RolesService = {
  async getPages() {
    const res = await axios.get('rbac/v1/modules/pages/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createRole(data) {
    const res = await axios.post('rbac/v1/roles/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async editRole(data, id) {
    const res = await axios.put(`rbac/v1/roles/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getRoles(page, perPage) {
    const params = generateQueryParams({
      page,
      size: perPage,
    });

    const res = await axios.get('rbac/v1/roles/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getRole(id) {
    const res = await axios.get(`rbac/v1/roles/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteRole(id) {
    const res = await axios.delete(`rbac/v1/roles/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
